export enum UserRolesEnum {
  Affiliate = 'ROLE_AFFILIATE',
  Student = 'ROLE_STUDENT',
  Customer = 'ROLE_CUSTOMER',
}
